/**
 * This component has been migrated to the Duo-UI library (https://gitlab.com/gitlab-org/duo-ui).
 *
 * Please use the corresponding component in Duo-UI going forward.
 * All future development and maintenance for Duo components should take place in Duo-UI.
 *
 * For more details, see the migration epic: https://gitlab.com/groups/gitlab-org/-/epics/15344 or reach out to the Duo-Chat team in #g_duo_chat.
 */

const CONTEXT_ITEM_CATEGORY_ISSUE = 'issue';
const CONTEXT_ITEM_CATEGORY_MERGE_REQUEST = 'merge_request';
const CONTEXT_ITEM_CATEGORY_FILE = 'file';
const CONTEXT_ITEM_CATEGORY_LOCAL_GIT = 'local_git';
const CONTEXT_ITEM_CATEGORY_DEPENDENCY = 'dependency';
const CONTEXT_ITEM_LOCAL_GIT_COMMIT = 'commit';
const CONTEXT_ITEM_LOCAL_GIT_DIFF = 'diff';
const LANGUAGE_IDENTIFIER_PREFIX = 'language-';
const LANGUAGE_IDENTIFIER_DIFF = 'language-diff';
const LANGUAGE_IDENTIFIER_PLAINTEXT = 'language-plaintext';

export { CONTEXT_ITEM_CATEGORY_DEPENDENCY, CONTEXT_ITEM_CATEGORY_FILE, CONTEXT_ITEM_CATEGORY_ISSUE, CONTEXT_ITEM_CATEGORY_LOCAL_GIT, CONTEXT_ITEM_CATEGORY_MERGE_REQUEST, CONTEXT_ITEM_LOCAL_GIT_COMMIT, CONTEXT_ITEM_LOCAL_GIT_DIFF, LANGUAGE_IDENTIFIER_DIFF, LANGUAGE_IDENTIFIER_PLAINTEXT, LANGUAGE_IDENTIFIER_PREFIX };
